import { gql } from "apollo-angular";
import { ASSET_FRAGMENT } from "../../../../graphql/fragments.graphql";

export const GET_LANDING_COLLECTIONS = gql`
    query GetCollections($options: CollectionListOptions) {
        collections(options: $options) {
            items {
                id
                name
                slug
                customFields {
                    commingSoon
                }
                parent {
                    id
                    name
                    slug
                }
                featuredAsset {
                    ...Asset
                }
                languageCode
                translations {
                    id
                    slug
                    languageCode
                    name
                    description
                    createdAt
                    updatedAt
                }
                landingFilters {
                    id
                    languageCode
                    name
                    code
                    values {
                        id
                        languageCode
                        filterId
                        name
                        code
                        count
                    }
                }


            }
        }
    }
    ${ASSET_FRAGMENT}
`;